<template>
  <v-card-text>
    <v-container>
      <v-row>
        <v-col>
          <v-card color="grey" flat rounded="xl" class="px-12 py-9">
            <v-card-title class="py-6">
              <v-icon size="32" class="mr-4">
                {{ icons.mdiAccount }}
              </v-icon>
              <span class="text-body-1 font-weight-bold"> Müşteri Bilgileri</span>
            </v-card-title>
            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Ad Soyad </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.fullname }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> Telefon </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.phone }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>

            <v-list-item>
              <v-list-item-content class="flex-grow-1">
                <v-list-item-title> E-Posta </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content style="flex-grow: 2 !important">
                <v-list-item-title>
                  {{ callCenterStore.email }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card-text>
</template>

<script>
// Store
import { useCallCenterStore } from "@/stores/callCenter";
import { mdiAccount } from "@mdi/js";
export default {
  setup() {
    const callCenterStore = useCallCenterStore();
    return {
      callCenterStore,
      icons: { mdiAccount },
    };
  },
};
</script>

<style></style>
